"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fetcher = void 0;
var querystring_1 = __importDefault(require("querystring"));
var moment_1 = __importDefault(require("moment"));
var BrowserWindowId_1 = require("./BrowserWindowId");
var Fetcher = /** @class */ (function () {
    function Fetcher(options) {
        this.preflight = [];
        this.on401 = options.on401;
        this.defaultHeaders = new Headers({
            accept: 'application/json',
            'X-BrowserWindowId': BrowserWindowId_1.browserWindowId,
        });
        if (options.apiVersion) {
            this.defaultHeaders.append('X-APIVersion', options.apiVersion);
        }
        this.defaultHeaders.append('X-TimezoneOffsetMins', (0, moment_1.default)().utcOffset().toString());
    }
    Fetcher.prototype.updatePath = function (path) {
        return path;
    };
    Fetcher.prototype.download = function (method, path, urlParameters) {
        path = this.updatePath(path);
        if (urlParameters) {
            path = path + '?' + querystring_1.default.stringify(urlParameters);
        }
        // @ts-ignore
        window.location = path;
    };
    Fetcher.prototype.getHeaders = function (add) {
        if (!add || Object.keys(add).length === 0)
            return this.defaultHeaders;
        var hd = new Headers(this.defaultHeaders);
        for (var k in add) {
            hd.set(k, add[k]);
        }
        return hd;
    };
    Fetcher.prototype.postFormData = function (path, body, isRetry) {
        if (isRetry === void 0) { isRetry = false; }
        return __awaiter(this, void 0, void 0, function () {
            var fd, i, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.updatePath(path);
                        fd = new FormData();
                        for (i in body) {
                            fd.append(i, body[i]);
                        }
                        return [4 /*yield*/, this.fetch(path, {
                                method: 'POST',
                                headers: this.getHeaders(),
                                credentials: 'include',
                                cache: 'no-cache',
                                redirect: 'follow',
                                body: fd,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.handleFetchResponse(result, function () { return _this.postFormData(path, body, true); }, isRetry)];
                }
            });
        });
    };
    Fetcher.prototype.fetchWithProgress = function (method, path, body, onProgress, hooks) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.updatePath(path);
                        return [4 /*yield*/, this.xhr(path, {
                                method: method,
                                headers: this.getHeaders(),
                                credentials: 'include',
                                cache: 'no-cache',
                                redirect: 'follow',
                                body: body,
                            }, onProgress, hooks)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.handleXhrResponse(result)];
                }
            });
        });
    };
    Fetcher.prototype.postFormDataWithProgress = function (path, body, onProgress, hooks, isRetry) {
        if (hooks === void 0) { hooks = null; }
        if (isRetry === void 0) { isRetry = false; }
        return __awaiter(this, void 0, void 0, function () {
            var fd, i, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.updatePath(path);
                        fd = new FormData();
                        for (i in body) {
                            fd.append(i, body[i]);
                        }
                        return [4 /*yield*/, this.xhr(path, {
                                method: 'POST',
                                headers: this.getHeaders(),
                                credentials: 'include',
                                cache: 'no-cache',
                                redirect: 'follow',
                                body: fd,
                            }, onProgress, hooks)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.handleXhrResponse(result, function () { return _this.postFormDataWithProgress(path, body, onProgress, hooks, true); }, isRetry)];
                }
            });
        });
    };
    Fetcher.prototype.xhr = function (path, params, onProgress, hooks) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var input_1 = {
                    path: path,
                    params: params,
                };
                input_1 = _this.preflight.reduce(function (acc, item) { return item(acc); }, input_1);
                if (hooks && hooks.input) {
                    input_1 = hooks.input(input_1);
                }
                var xhr_1 = new XMLHttpRequest();
                xhr_1.open(input_1.params.method || 'GET', input_1.path, true);
                if (input_1.params.cache === 'no-cache') {
                    xhr_1.setRequestHeader('Cache-Control', 'no-cache');
                }
                if (input_1.params.headers) {
                    if (input_1.params.headers instanceof Array) {
                        input_1.params.headers.map(function (pair) { return xhr_1.setRequestHeader(pair[0], pair[1]); });
                    }
                    else if ('forEach' in input_1.params.headers) {
                        // @ts-ignore
                        input_1.params.headers.forEach(function (value, key, parent) {
                            xhr_1.setRequestHeader(key, value);
                        });
                    }
                    else {
                        for (var key in input_1.params.headers) {
                            if (input_1.params.headers.hasOwnProperty(key)) {
                                xhr_1.setRequestHeader(key, input_1.params.headers[key]);
                            }
                        }
                    }
                }
                xhr_1.withCredentials = input_1.params.credentials !== 'omit';
                xhr_1.upload.addEventListener('progress', onProgress, false);
                xhr_1.addEventListener('abort', function (e) { return reject(e); });
                xhr_1.addEventListener('error', function (e) { return reject(e); });
                xhr_1.addEventListener('load', function (e) {
                    if (xhr_1.readyState !== 4)
                        return;
                    var location = null;
                    try {
                        // ignore failures to get the Location header
                        // sometimes this happens when it's blocked by CORS
                        location = xhr_1.getResponseHeader('Location');
                    }
                    catch (e) { }
                    if (location) {
                        if (input_1.params.redirect === 'follow') {
                            _this.xhr(location, params, onProgress).then(resolve, reject);
                            return;
                        }
                        if (input_1.params.redirect === 'error') {
                            reject('Received redirect');
                            return;
                        }
                    }
                    resolve(xhr_1);
                });
                if (hooks && hooks.preSend) {
                    hooks.preSend(xhr_1);
                }
                if (input_1.params.body) {
                    xhr_1.send(input_1.params.body);
                }
                else {
                    xhr_1.send();
                }
            }
            catch (e) {
                reject(e);
            }
        });
    };
    Fetcher.prototype.fetch = function (path, params) {
        var input = {
            path: path,
            params: params,
        };
        input = this.preflight.reduce(function (acc, item) { return item(acc); }, input);
        return fetch(input.path, input.params);
    };
    Fetcher.prototype.postForAuth = function (path, body) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.updatePath(path);
                        return [4 /*yield*/, this.fetch(path, {
                                method: 'POST',
                                headers: this.getHeaders({
                                    'Content-Type': 'application/json',
                                }),
                                credentials: 'include',
                                cache: 'no-cache',
                                redirect: 'follow',
                                body: JSON.stringify(body),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.handleFetchResponse(result)];
                }
            });
        });
    };
    Fetcher.prototype.post = function (path, body, isRetry) {
        if (isRetry === void 0) { isRetry = false; }
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.updatePath(path);
                        return [4 /*yield*/, this.fetch(path, {
                                method: 'POST',
                                headers: this.getHeaders({
                                    'Content-Type': 'application/json',
                                }),
                                credentials: 'include',
                                cache: 'no-cache',
                                body: JSON.stringify(body),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.handleFetchResponse(result, function () { return _this.post(path, body, true); }, isRetry)];
                }
            });
        });
    };
    Fetcher.prototype.put = function (path, body, retry) {
        if (retry === void 0) { retry = false; }
        return __awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.updatePath(path);
                        return [4 /*yield*/, this.fetch(path, {
                                method: 'PUT',
                                headers: this.getHeaders({
                                    'Content-Type': 'application/json',
                                }),
                                credentials: 'include',
                                cache: 'no-cache',
                                redirect: 'follow',
                                body: JSON.stringify(body),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.handleFetchResponse(result, function () { return _this.put(path, body, true); }, retry)];
                }
            });
        });
    };
    Fetcher.prototype.get = function (path, urlParameters, isRetry) {
        if (isRetry === void 0) { isRetry = false; }
        return __awaiter(this, void 0, void 0, function () {
            var fullPath, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = this.updatePath(path);
                        fullPath = path;
                        if (urlParameters) {
                            fullPath = path + '?' + querystring_1.default.stringify(urlParameters);
                        }
                        return [4 /*yield*/, this.fetch(fullPath, {
                                method: 'GET',
                                headers: this.getHeaders(),
                                credentials: 'include',
                                cache: 'no-cache',
                                redirect: 'follow',
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.handleFetchResponse(result, function () { return _this.get(path, urlParameters, true); }, isRetry)];
                }
            });
        });
    };
    Fetcher.prototype.handleXhrResponse = function (xhr, retry, isRetry) {
        if (isRetry === void 0) { isRetry = false; }
        return __awaiter(this, void 0, void 0, function () {
            var contentType, isNotJsonContentType, noContent, jsonData;
            return __generator(this, function (_a) {
                if (!isRetry && xhr.status === 401 && retry) {
                    return [2 /*return*/, this.on401(retry)];
                }
                contentType = xhr.getResponseHeader('Content-Type');
                isNotJsonContentType = contentType && contentType.indexOf('json') === -1;
                noContent = !contentType && !xhr.responseText;
                if (isNotJsonContentType || noContent) {
                    if (xhr.status >= 400) {
                        throw new FetcherError(xhr.status + ' ' + xhr.statusText, { xhr: xhr });
                    }
                    return [2 /*return*/, xhr];
                }
                jsonData = JSON.parse(xhr.responseText);
                if (jsonData && typeof jsonData === 'object' && 'error' in jsonData) {
                    throw new Error(jsonData.error);
                }
                if (!this.isOkStatus(xhr.status)) {
                    throw new Error(jsonData);
                }
                return [2 /*return*/, jsonData];
            });
        });
    };
    Fetcher.prototype.isOkStatus = function (value) {
        return value < 400;
    };
    Fetcher.prototype.handleFetchResponse = function (result, retry, isRetry) {
        if (isRetry === void 0) { isRetry = false; }
        return __awaiter(this, void 0, void 0, function () {
            var contentType, jsonData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isRetry && result.status === 401 && retry) {
                            return [2 /*return*/, this.on401(retry)];
                        }
                        contentType = result.headers.get('Content-Type');
                        if (contentType && contentType.indexOf('json') === -1) {
                            if (result.status === 404) {
                                throw new Error('Not found');
                            }
                            return [2 /*return*/, result];
                        }
                        return [4 /*yield*/, result.json()];
                    case 1:
                        jsonData = _a.sent();
                        if (jsonData && typeof jsonData === 'object' && 'error' in jsonData) {
                            throw new Error(jsonData.error);
                        }
                        if (!result.ok) {
                            throw new Error(jsonData);
                        }
                        return [2 /*return*/, jsonData];
                }
            });
        });
    };
    return Fetcher;
}());
exports.Fetcher = Fetcher;
var FetcherError = /** @class */ (function (_super) {
    __extends(FetcherError, _super);
    function FetcherError(msg, info) {
        var _this = _super.call(this, msg) || this;
        _this.info = info;
        return _this;
    }
    return FetcherError;
}(Error));
